import React from "react";

export default function AboutFestival() {
  return (
    <>
      <div className="fq-faq-area fq-faq-bdr  pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <h1 className="text-color-yellow bold-text">
                About Tribe O Crypto Festival
              </h1>
              <div className="fq-faq-wrapper">
                <div className="tp-service-2-accordion-box">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse13"
                          aria-expanded="true"
                          aria-controls="collapse13"
                        >
                          What is the Tribe O Crypto Festival?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse13"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Tribe O Crypto is the world’s first
                            blockchain-powered music and networking festival,
                            featuring:
                          </p>
                          <div className="tp-about-2-content">
                            <span>World-Class DJs & Performances</span>
                            <p className="mb-30">
                              Top 10 global DJs perform live.
                            </p>
                            <span>Blockchain Gaming Arena</span>
                            <p className="mb-30">
                              Compete in crypto-based play-to-earn games.
                            </p>
                            <span>Networking & Business Opportunities</span>
                            <p className="mb-30">
                              Connect with Web3 innovators & investors.
                            </p>
                            <span>NFT Marketplace & Live Auctions</span>
                            <p className="mb-30">
                              Buy, sell, and trade rare NFTs & collectibles.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse14"
                          aria-expanded="false"
                          aria-controls="collapse14"
                        >
                          Where and when will the festival take place?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse14"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div class="service-details__fea-list">
                            <ul>
                              <li>Location: Abu Dhabi, UAE</li>
                              <li>Dates: October 16-18, 2025</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse15"
                          aria-expanded="false"
                          aria-controls="collapse15"
                        >
                          How can I attend the festival?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse15"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            To attend the Tribe O Crypto Festival, you must buy
                            tickets from Kryptogram:
                          </p>
                          <div class="service-details__fea-list">
                            <ul>
                              <li>Elite</li>
                              <li>Super Elite</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse16"
                          aria-expanded="false"
                          aria-controls="collapse16"
                        >
                          What are the benefits of a Crypto Whale NFT?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse16"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <div class="service-details__fea-list">
                            <ul>
                              <li>
                                Helicopter Transfers – Direct transport to the
                                festival.
                              </li>
                              <li>
                                VIP Lounges & Concierge Services – Private areas
                                for networking & relaxation.
                              </li>
                              <li>
                                Premium Seating – The best views for
                                performances & live panels.
                              </li>
                              <li>
                                Exclusive Networking Events – Direct access to
                                crypto leaders & investors.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse17"
                          aria-expanded="false"
                          aria-controls="collapse17"
                        >
                          Can I attend the event without buying an NFT?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse17"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            No, only Kryptogram NFT holders can enter the Tribe
                            O Crypto Festival. There are no traditional ticket
                            sales.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
